import script from "./articlePage.vue?vue&type=script&setup=true&lang=js"
export * from "./articlePage.vue?vue&type=script&setup=true&lang=js"

import "./articlePage.vue?vue&type=style&index=0&id=a04b3392&lang=less"

const __exports__ = script;

export default __exports__